<template>
  <div class="h-screen" :class="[`bg-${$route.meta.background}`]">
    <eggos
      v-if="$route.meta.eggos !== undefined"
      :color="$route.meta.eggos"
    ></eggos>
    <transition name="page" mode="out-in">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Eggos from '../components/Eggos.vue';

export default {
  name: 'ForgotPasswordLayout',

  components: {
    Eggos,
  },
};
</script>
